export interface ComparisonRow {
  topic: string
  without: string
  with: string
}

export const comparison: ComparisonRow[] = [
  {
    topic: 'Planificación semanal',
    without: '8 a 10 horas por semana buscando ideas',
    with: '10 minutos: copiar, pegar y enseñar',
  },
  {
    topic: 'Estructura del año',
    without: 'Improvisás según la semana',
    with: 'Año entero mapeado desde el día 1',
  },
  {
    topic: 'Progresión motriz',
    without: 'Los alumnos repiten los mismos ejercicios',
    with: 'Progresión lógica y medible',
  },
  {
    topic: 'Evaluación',
    without: 'Solo notas subjetivas',
    with: 'Rúbricas objetivas más informes',
  },
  {
    topic: 'Confianza en el patio',
    without: 'Llegás sin un plan claro',
    with: 'Entrás sabiendo exactamente qué hacer',
  },
  {
    topic: 'Participación del grupo',
    without: 'Se aburren y baja la participación',
    with: 'Piden que la clase no termine',
  },
  {
    topic: 'Conversación con familias',
    without: '“Le va bien” o “necesita mejorar”',
    with: 'Datos concretos de progreso',
  },
  {
    topic: 'Tu carga emocional',
    without: 'Alta: siempre estás preparando algo',
    with: 'Baja: el sistema va en piloto automático',
  },
]
